import React, { useEffect } from "react"
import { isRouteErrorResponse, useRouteError } from "react-router-dom"

import { notifyBugsnag } from "src/utils/bugsnag"

import ErrorFallback from "./ErrorFallback"

// Data routers catch render errors in their own boundary, so the app-level
// ErrorBoundaryProvider never sees them. Each router's root route renders this.
const RouteErrorFallback = () => {
  const error = useRouteError()

  useEffect(() => {
    // Hash routers read the layout's "#yield" skip link as an unknown route.
    if (isRouteErrorResponse(error) && error.status === 404) return

    notifyBugsnag(
      isRouteErrorResponse(error)
        ? new Error(`Route error ${error.status}: ${error.statusText}`)
        : error,
      {},
      { unhandled: true }
    )
  }, [error])

  return <ErrorFallback />
}

export default RouteErrorFallback
